export default __webpack_public_path__ + "static/tazo-77afdbfd2e33ff8bf7ab90ed50cd1b0d.png";